// extracted by mini-css-extract-plugin
export default {"internet-tele__txt":"flashsale_internet-tele__txt__hsgEQ"};